module.exports = __webpack_public_path__ + "static/img/allapp2.e107507.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/allapp2.svg
// module id = ZdXE
// module chunks = 1